import { createFileRoute } from '@tanstack/react-router';
import { AdminMemberDetailView } from '@/components/admin/AdminMemberDetailView';
import { AdminShell } from '@/components/admin/AdminShell';
import { PLATFORM_ADMIN_ITEMS } from '@/components/admin/admin-sidebar-items';

export const Route = createFileRoute('/_authed/admin/members/$userId')({
  component: AdminMemberEditPage,
});

function AdminMemberEditPage() {
  const { userId } = Route.useParams();
  return (
    <AdminShell items={PLATFORM_ADMIN_ITEMS} active="members">
      <AdminMemberDetailView userId={userId} />
    </AdminShell>
  );
}
